// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__PwGt7","empty":"ModalGraph_empty__aCnfS"};